import * as api from "../../../APICalls/index";
import jwt_decode from "jwt-decode";
import { Action, AnyAction, Dispatch } from "redux";
import { UserActionType } from "../../../../Types";
import toast from "react-hot-toast";

type formDataType = {
  email: string;
  password: string;
};

export const authLogin = (
  formData: formDataType,
  CaptchaValue: string
) => async (dispatch: Dispatch<UserActionType>) => {
  try {
    const response = await api.LoginAdmin(formData, CaptchaValue);
    console.log(JSON.stringify(response));
    if (response.status === 200) {
      //cookies 1
      const role = response.data.user.role;
      if (role === "subadmin" || role === "musaliadmin") {
        return {
          success: false,
          error: "You are not authorized to access this page",
          data: null,
        };
      }
      localStorage.setItem("authTokens", JSON.stringify(response.data.token));
      // setCookie('authTokens', response.data.data.token, 7);
      dispatch({ type: "AUTH_LOGIN", payload: response.data.user });

      window.location.reload();
      return { success: true, data: response.data };
    }

    return response.data;
  } catch (error) {
    return { success: false, error: "Failed to Login", data: null };
  }
};
